import React from 'react';
import { formatTimecode, formatTimeOnly } from '../utils/timecodeFormatter';

interface TimecodeDisplayProps {
  value: number;
  fps?: number;
  startFrame?: number;
  dropFrame?: boolean;
  /** Text prepended to the timecode string (e.g. "−" for remaining time). */
  prefix?: string;
  className?: string;
  onClick?: () => void;
}

export function TimecodeDisplay({
  value,
  fps,
  startFrame = 0,
  dropFrame = false,
  prefix,
  className,
  onClick,
}: TimecodeDisplayProps) {
  const currentTC = fps
    ? formatTimecode(value, fps, startFrame, dropFrame)
    : formatTimeOnly(value);

  const display = prefix ? `${prefix}${currentTC}` : currentTC;

  const isClickable = !!onClick;

  const classes = [
    'kollab-player-timecode',
    isClickable ? 'kollab-player-timecode--clickable' : '',
    className ?? '',
  ].filter(Boolean).join(' ');

  return (
    <span
      className={classes}
      aria-label={display}
      onClick={onClick}
      role={isClickable ? 'button' : undefined}
      tabIndex={isClickable ? 0 : undefined}
    >
      {display}
    </span>
  );
}
